import { render, staticRenderFns } from "./PeriodSalesTable.vue?vue&type=template&id=06926853&"
import script from "./PeriodSalesTable.vue?vue&type=script&lang=js&"
export * from "./PeriodSalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports